import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const teacherImages = {
  herr_amr: 'https://images.unsplash.com/photo-1752486268262-6ce6b339a8de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtaWRkbGUlMjBlYXN0ZXJuJTIwbWFsZSUyMHRlYWNoZXIlMjBnbGFzc2VzJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzY4ODU3Mjg0fDA&ixlib=rb-4.1.0&q=85&w=400',
  frau_rasha: 'https://images.unsplash.com/photo-1741868159744-159b83484687?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxtaWRkbGUlMjBlYXN0ZXJuJTIwZmVtYWxlJTIwbnVyc2luZyUyMGluc3RydWN0b3IlMjBoaWphYiUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc2ODg1NzI4N3ww&ixlib=rb-4.1.0&q=85&w=400',
};

export const AvatarContainer = ({ 
  teacher = 'frau_rasha', 
  size = 'md',
  showName = true,
  speaking = false,
  className = ''
}) => {
  const { t } = useLanguage();
  
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
    xl: 'w-48 h-48',
    full: 'w-full h-64 lg:h-full',
  };

  const teacherInfo = {
    herr_amr: {
      name: t('herrAmr'),
      role: t('herrAmrRole'),
      color: 'from-slate-600 to-slate-800',
    },
    frau_rasha: {
      name: t('frauRasha'),
      role: t('frauRashaRole'),
      color: 'from-teal-500 to-teal-700',
    },
  };

  const info = teacherInfo[teacher];

  return (
    <div 
      className={`avatar-container relative rounded-xl overflow-hidden ${sizeClasses[size]} ${className}`}
      data-testid={`avatar-${teacher}`}
    >
      <img
        src={teacherImages[teacher]}
        alt={info.name}
        className={`w-full h-full object-cover transition-transform duration-300 ${speaking ? 'scale-105' : ''}`}
      />
      
      {/* Speaking indicator */}
      {speaking && (
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-400 animate-pulse" />
        </div>
      )}
      
      {/* Name tag overlay */}
      {showName && size !== 'sm' && (
        <div className="avatar-name-tag absolute bottom-0 left-0 right-0 p-3 bg-white/10 backdrop-blur-md border-t border-white/20">
          <p className="font-heading font-semibold text-white text-sm">{info.name}</p>
          <p className="text-white/70 text-xs">{info.role}</p>
        </div>
      )}
      
      {/* Gradient overlay */}
      <div className={`absolute inset-0 bg-gradient-to-t ${info.color} opacity-20 pointer-events-none`} />
    </div>
  );
};

export const TeacherToggle = ({ selected, onChange }) => {
  const { t } = useLanguage();
  
  return (
    <div className="teacher-toggle inline-flex bg-slate-100 dark:bg-slate-800 rounded-full p-1" data-testid="teacher-toggle">
      <button
        onClick={() => onChange('frau_rasha')}
        className={`teacher-toggle-btn flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all ${
          selected === 'frau_rasha' 
            ? 'bg-white dark:bg-slate-700 shadow-md' 
            : 'hover:bg-white/50 dark:hover:bg-slate-700/50'
        }`}
        data-testid="toggle-frau-rasha"
      >
        <img 
          src={teacherImages.frau_rasha} 
          alt="Frau Rasha" 
          className="w-6 h-6 rounded-full object-cover"
        />
        <span className="hidden sm:inline">{t('frauRasha')}</span>
      </button>
      
      <button
        onClick={() => onChange('herr_amr')}
        className={`teacher-toggle-btn flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all ${
          selected === 'herr_amr' 
            ? 'bg-white dark:bg-slate-700 shadow-md' 
            : 'hover:bg-white/50 dark:hover:bg-slate-700/50'
        }`}
        data-testid="toggle-herr-amr"
      >
        <img 
          src={teacherImages.herr_amr} 
          alt="Herr Amr" 
          className="w-6 h-6 rounded-full object-cover"
        />
        <span className="hidden sm:inline">{t('herrAmr')}</span>
      </button>
    </div>
  );
};
